import { updateObject, generateCompanyOptionsFromAmplifyData } from './../../utils/utility';

const initialState = {
    userId: "",
    firstName: "",
    lastName: "",
    emailAddress: "",
    contactNo: "",
    company: "",
    country: "",
    region: "",
    language: "",
    accountType: "",
    role: "",
    userType: "customer",
    simplifiedUserType: "Customer",
    partnerType: "personal",
    imageUrl: "",
    isDeleted: false,
    createdDate: "",
    isFavourite: false,
    address1: null,
    address2: null,
    address3: null,
    address4: null,
    address5: null,
    region: "",
    envId: "",
    companyTaxId: "",
    customerSegment: "",
    personalTaxId: "",
    customerId: "",
    contactId: "",
    shippingAndReceivingHours: "",
    shippingAddresses: [],
    billingAddresses: [],
    contacts: [],
    authenticated: false,
    hasServerResponded: false,
    dataUpdated: false,
    confirmedCheckoutAsGuest: false,
    userProfileUpdateErrorType: "",
    companyList: [],
    lspId: null,
    priceList: null,
    hpPartnerData: [],
    partnerId: "",
    locationId: "",
    amplifyProgram: "",
    hpPickUp: "",
    amplifySearchText: "",
    customerType: "indirect",
    ctProfiles: [],
    checkoutOption: "",
    orgId: "",
    legalEntity: "",
    legalEntityName: "",
    legalEntityId: "",
    poNumber: "",
    salesContractId: "",
    visibleCountries: [],
    visibleRegions: [],
    vendorList: [],
    indirectCustOrder: false,
    revitalize: false,
};

const setUserProfile = (state = initialState, action) => {
    const data = action.payload;
    const authenticated = data.userId && data.emailAddress ? true : false;

    const nonCustomerUserTypes = ["Manager", "Vendor", "ControlTower"];
    const simplifiedUserType = data.userType && nonCustomerUserTypes.includes(data.userType) ? data.userType : "Customer";

    const updatedObject = updateObject(state, {
        userId: data.userId ? data.userId : "",
        firstName: data.firstName ? data.firstName : "",
        lastName: data.lastName ? data.lastName : "",
        emailAddress: data.emailAddress ? data.emailAddress : "",
        contactNo: data.contactNo ? data.contactNo : "",
        company: data.company ? data.company : "",
        country: data.country ? data.country : "",
        region: data.region ? data.region : "",
        language: data.language ? data.language : "",
        accountType: data.accountType ? data.accountType : "",
        role: data.role ? data.role : "",
        userType: data.userType ? data.userType : "",
        simplifiedUserType: simplifiedUserType,
        partnerType: data.partnerType ? data.partnerType : "",
        imageUrl: data.imageUrl ? data.imageUrl : "",
        isDeleted: data.isDeleted ? true : false,
        createdDate: data.createdDate ? data.createdDate : "",
        isFavourite: data.isFavourite ? true : false,
        region: data.region ? data.region : "",
        envId: data.envId ? data.envId : "",
        companyTaxId: data.companyTaxId ? data.companyTaxId : "",
        personalTaxId: data.personalTaxId ? data.personalTaxId : "",
        customerSegment: data.customerSegment ? data.customerSegment : "",
        customerId: data.customerId ? data.customerId : "",
        contactId: data.contactId ? data.contactId : "",
        shippingAndReceivingHours: data.shippingAndReceivingHours ? data.shippingAndReceivingHours : "",
        lspId: data.lspId ? data.lspId : null,
        priceList: data.priceList ? data.priceList : null,
        shippingAddresses: data.shippingAddresses && data.shippingAddresses.length ? data.shippingAddresses : [],
        billingAddresses: data.billingAddresses && data.billingAddresses.length ? data.billingAddresses : [],
        contacts: data.contacts && data.contacts.length ? data.contacts : [],
        hasServerResponded: true,
        dataUpdated: true,
        authenticated: authenticated,
        userProfileUpdateErrorType: "",
        partnerId: data.partnerId ? data.partnerId : "",
        locationId: data.locationId ? data.locationId : "",
        amplifyProgram: data.hasOwnProperty("amplifyProgram") ? data.amplifyProgram : null,
        hpPickUp: data.hasOwnProperty("hpPickUp") ? data.hpPickUp : null,
        amplifySearchText: data.amplifySearchText ? data.amplifySearchText : "",
        customerType: data.customerType ? data.customerType : "",
        checkoutOption: data.checkoutOption ? data.checkoutOption : "",
        orgId: data.orgId ? data.orgId : "",
        legalEntity: data.legalEntity ? data.legalEntity : "",
        legalEntityName: data.legalEntityName ? data.legalEntityName : "",
        legalEntityId: data.legalEntityId ? data.legalEntityId : "",
        poNumber: data.poNumber ? data.poNumber : "",
        vendorName: data.vendorName ? data.vendorName : "",
        salesContractId: data.salesContractId ? data.salesContractId : "",
        visibleRegions: data.visibleRegions ? data.visibleRegions : "",
        visibleCountries: data.visibleCountries ? data.visibleCountries : "",
        indirectCustOrder: data.indirectCustOrder ? data.indirectCustOrder : false,
        revitalize: data.revitalize ? data.revitalize : false,
    });

    return updatedObject;
};

const setVendorList = (state = initialState, action) => {
    return updateObject(state, {
       vendorList: action.data,
    });
}

const setUserAddress = (state = initialState, action) => {
    const index = action.index;
    return updateObject(state, {
        ['address' + index]: action.data,
    });
};

const setHasResponded = (state = initialState, action) => {
    return updateObject(state, {
        hasServerResponded: action.data,
    });
};

const setImageUrl = (state = initialState, action) => {
    return updateObject(state, {
        imageUrl: action.data
    });
};

const setDataUpdated = (state = initialState, action) => {
    return updateObject(state, {
        dataUpdated: action.data
    });
};

const setUserProfileUpdateErrorType = (state = initialState, action) => {
    return updateObject(state, {
        userProfileUpdateErrorType: action.data
    });
};

const setConfirmedCheckoutAsGuest = (state = initialState, action) => {
    return updateObject(state, {
        confirmedCheckoutAsGuest: true
    });
};

const setCompanies = (state = initialState, action) => {
    let listOfCompanies = !!action.data ? [...action.data] : [];
    return updateObject(state, {
        companyList: listOfCompanies.map(company => ({ id: company, label: company })),
    });
};

const setHpPartnerData = (state = initialState, action) => {
    let listOfCompanies = !!action.data ? [...action.data] : [];
    return updateObject(state, {
        hpPartnerData: generateCompanyOptionsFromAmplifyData(listOfCompanies),
    });
};

const setCTList = (state = initialState, action) => {
    return updateObject(state, {
        ctProfiles: action.data,
    });
};

const resetUserProfileContent = (state = initialState) => {
    return updateObject(state, { ...initialState });
}

const reducer = (state = initialState, action) => {
    if (action.type === "SET_USER_PROFILE_DATA") {
        return setUserProfile(state, action);
    }
    else if (action.type === "SET_USER_ADDRESS") {
        return setUserAddress(state, action);
    }
    else if (action.type === "SET_HAS_RESPONDED") {
        return setHasResponded(state, action)
    }
    else if (action.type === "SET_DATA_UPDATED") {
        return setDataUpdated(state, action)
    }
    else if (action.type === "SET_IMAGE_URL") {
        return setImageUrl(state, action)
    }
    else if (action.type === "SET_SURVEYS_COMPANIES") {
        return setCompanies(state, action)
    }
    else if (action.type === "SET_HP_PARTNER_DATA") {
        return setHpPartnerData(state, action)
    }
    else if (action.type === "SET_CONFIRMED_CHECKOUT_AS_GUEST") {
        return setConfirmedCheckoutAsGuest(state, action)
    }
    else if (action.type === "SET_USER_PROFILE_ERROR_TYPE") {
        return setUserProfileUpdateErrorType(state, action)
    }
    else if (action.type === "SET_CT_LIST") {
        return setCTList(state, action)
    }
    else if (action.type === "RESET_USERPROFILE_CONTENT") {
        return resetUserProfileContent(state, action)
    }
    else if (action.type === "SET_VENDOR_LIST") {
        return setVendorList(state, action)
    }
    return state;
};

export default reducer;
